export const KLAT = 111319.49079327358;
export const KLON = 84395.12825841912;
export const TILE_METERS = 20;
export type Rotation = 0|1|2|3;
export type Zoom = number;
export interface CameraState { center: [number,number]; zoom: Zoom; rotation: Rotation }
export const geoToWorld = ([lon,lat]: [number,number]): [number,number] => [(lon + 74) * KLON, (lat - 40.7) * KLAT];
export const worldToGeo = ([e,n]: [number,number]): [number,number] => [e / KLON - 74, n / KLAT + 40.7];
export const worldToTile = ([e,n]: [number,number]): [number,number] => [(e + 26000) / TILE_METERS, (28000 - n) / TILE_METERS];
export const tileToWorld = ([x,y]: [number,number]): [number,number] => [x * TILE_METERS - 26000, 28000 - y * TILE_METERS];
export const geoToTile = (geo: [number,number]): [number,number] => worldToTile(geoToWorld(geo));
export const tileToGeo = (tile: [number,number]): [number,number] => worldToGeo(tileToWorld(tile));
export const rotate = ([x,y]: [number,number], q: Rotation): [number,number] => q === 0 ? [x,y] : q === 1 ? [-y,x] : q === 2 ? [-x,-y] : [y,-x];
export const unrotate = (point: [number,number], q: Rotation): [number,number] => rotate(point, ((4 - q) % 4) as Rotation);
export function tileToScreen(tile: [number,number], camera: CameraState, height = 0): [number,number] {
  if (!Number.isFinite(camera.zoom) || camera.zoom <= 0) throw new Error('zoom must be finite and positive');
  const [x,y] = rotate([tile[0] - camera.center[0], tile[1] - camera.center[1]], camera.rotation);
  return [camera.zoom * 32 * (x - y), camera.zoom * (16 * (x + y) - 8 * height)];
}
export function screenToTile(screen: [number,number], camera: CameraState, height = 0): [number,number] {
  if (!Number.isFinite(camera.zoom) || camera.zoom <= 0) throw new Error('zoom must be finite and positive');
  const a = screen[0] / (32 * camera.zoom), b = (screen[1] / camera.zoom + 8 * height) / 16;
  const [x,y] = unrotate([(a + b) / 2, (b - a) / 2], camera.rotation);
  return [x + camera.center[0], y + camera.center[1]];
}
